import { RouteBuilder } from "@/app/ui/navigation/routeBuilder";
import { type IRouteItem } from "@/app/ui/navigation/types";

const builder = new RouteBuilder("TpRoutes");

export const tpRoutes = {
  signIn: builder.routeWithParam(
    {
      url: "/:storeid/signin",
      view: (): Promise<any> =>
        import(
          /* webpackChunkName: "tenantportal" */ "@tp/account/SignInPage.vue"
        ),
      componentProps: (route) => ({
        storeId: route.params.storeid,
      }),
      preSession: true,
    },
    (storeId: string) => ({
      storeid: storeId,
    })
  ),
  products: {
    list: builder.route({
      url: "/:storeid/products/list-products",
      view: (): Promise<any> =>
        import(
          /* webpackChunkName: "tenantportal" */ "@tp/products/ListProductsPage.vue"
        ),
    }),
    view: builder.routeWithSingleIdParam({
      url: "/:storeid/products/view-product/:id",
      view: (): Promise<any> =>
        import(
          /* webpackChunkName: "tenantportal" */ "@tp/products/ViewProductPage.vue"
        ),
    }),
  },
  basket: {
    view: builder.route({
      url: "/:storeid/basket/view-basket",
      view: (): Promise<any> =>
        import(
          /* webpackChunkName: "tenantportal" */ "@tp/basket/ViewBasketPage.vue"
        ),
    }),
  },
  history: {
    list: builder.route({
      url: "/:storeid/history/list-orders",
      view: (): Promise<any> =>
        import(
          /* webpackChunkName: "tenantportal" */ "@tp/listorders/ListOrdersPage.vue"
        ),
    }),
    view: builder.routeWithSingleIdParam({
      url: "/:storeid/history/view-order/:id",
      view: (): Promise<any> =>
        import(
          /* webpackChunkName: "tenantportal" */ "@tp/listorders/ViewOrderPage.vue"
        ),
    }),
  },
  account: {
    view: builder.route({
      url: "/:storeid/account/view-account",
      view: (): Promise<any> =>
        import(
          /* webpackChunkName: "tenantportal" */ "@tp/account/ViewAccountPage.vue"
        ),
    }),
  },
};

export function getTpRouteItems(): readonly IRouteItem[] {
  return builder.getRoutes();
}
